import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/ParkSpace/parkSpacePage', Object.assign({}, options, { params }));

export const getTreeChildrenCarParkNode = (params, options) =>
  request.get(
    '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode',
    Object.assign({}, options, { params })
  );

export const addParkSpaceNode = (params, options) =>
  request.post('/api/v4ward/car/ParkSpace/saveNode', params, options);

export const getDetailById = (params, options) =>
  request.get('/api/v4ward/car/ParkSpace/detailById', Object.assign({}, options, { params }));

export const update = (params, options) =>
  request.post('/api/v4ward/car/ParkSpace/submit', params, options);

export const updateCarSpace = (params, options) =>
  request.post('/api/v4ward/car/ParkSpace/update/carspace', params, options);

export const addPark = (params, options) =>
  request.post('/api/v4ward/car/ParkSpace/addPark', params, options);

export const remove = (params, options) =>
  request.post('/api/v4ward/car/ParkSpace/remove', qs.stringify(params), options);

export const syncParkPositions = (params, options) =>
  request.post('/api/v4ward/car/ParkSpace/syncPosition', qs.stringify(params), options);
